// src/App.jsx
import { useState } from "react";
import { BottomNav } from "./components/ui/BottomNav";
import { Dashboard } from "./pages/Dashboard";
import { Transactions } from "./pages/Transactions";
import { Spending } from "./pages/Spending";
import { Investments } from "./pages/Investments";
import { AskAI } from "./pages/AskAI";
import "./index.css";

const SCREENS = {
  dashboard: Dashboard,
  transactions: Transactions,
  spending: Spending,
  investments: Investments,
  ai: AskAI,
};

export default function App() {
  const [activeTab, setActiveTab] = useState("dashboard");

  const Screen = SCREENS[activeTab] || Dashboard;

  return (
    <div className="min-h-screen bg-background max-w-lg mx-auto relative">
      {/* Main content area */}
      <main
        className="overflow-y-auto"
        style={{ height: "calc(100vh - 60px)" }}
      >
        <Screen />
      </main>

      {/* Bottom navigation */}
      <BottomNav active={activeTab} onChange={setActiveTab} />
    </div>
  );
}
